<template>
    <BreadCrumb PageTitle="Liste des Tarifications" />
    <ListeTarification/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTarification from "@/components/Tarification/ListeTarification.vue";
  
    export default defineComponent({
      name: "ListeTarificationPage",
      components: {
        BreadCrumb,
        ListeTarification,
      },
    });
  </script>